import {getAgentSignature} from '../../helpers/getAgentSignature';
import {QuoteTemplateParams} from '../quoteTemplateParams';
import {getHowToReadQuotesVideo} from '../../helpers/getHowToReadQuotesVideo';
import {highlightYellow} from '../../helpers/highlightYellow';
import {
    emailHeaderCompanyLogo,
    afterSaleGreeting,
    afterSaleIntroVideo,
    afterSaleNextSteps,
    afterSaleAlsoIncluded,
    aboutAmplify,
    illnessBrochure,
} from '../../helpers/commonEmailComponents';

export default function afterSaleGULTermBlend(params: QuoteTemplateParams) {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const {name, face_amount, monthly_premium, brochureLink, illnessSection, term_period, life_coverage, life_premium} =
        params;

    return `
${emailHeaderCompanyLogo}
<p>Dear ${highlightYellow(name)},</p>
${afterSaleGreeting}
${afterSaleIntroVideo}
<p><strong>In summary of what we've discussed, our life insurance policies can provide:</strong></p>
<ol>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">Immediate life insurance protection</span></li>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">Immediate critical, chronic, and terminal illness protection</span></li>
</ol>
<p><strong>Life insurance plan summary for ${highlightYellow(name)}</strong></p>
<ul>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">${highlightYellow(
        face_amount,
    )}</span><span style="font-weight: 400;"> life, critical, chronic, and terminal illness protection for the next ${highlightYellow(
        term_period,
    )} years, after ${highlightYellow(term_period)} years you will still have ${highlightYellow(
        life_coverage,
    )} remaining coverage for the rest of life</span></li>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">${highlightYellow(
        monthly_premium,
    )} per month (for the first ${highlightYellow(term_period)} years), after ${highlightYellow(
        term_period,
    )} years your premium drops to ${highlightYellow(life_premium)} per month for rest of life</span></li>
</ul>
${getHowToReadQuotesVideo(params)}
${afterSaleNextSteps}
${aboutAmplify}
${illnessBrochure(illnessSection, brochureLink)}
${afterSaleAlsoIncluded}
<p><span style="font-weight: 400;">Looking forward to speaking with you again and helping you get the coverage and savings you need for peace of mind!</span></p>
<p><span style="font-weight: 400;">Best,</span></p>
${getAgentSignature()}
	`;
}
